import axios from 'axios'
import { getToken } from '@/utils/auth'
import { objectToString } from "./index";


export function getExel(url, params, type = "POST") {

    return new Promise(function(resolve, reject) {


      axios({
        method: type||"POST",
        url:process.env.BASE_API + url + (type == "POST" ? "":("?" + objectToString(params))),
        headers: {
          'Authorization':  getToken()
        },
        data: params,
        responseType: 'blob'
      }).then(res=>{
         const blob = new Blob([res.data], { type:'application/vnd.ms-excel' })
         const link = document.createElement("a");
        link.href =URL.createObjectURL(blob);
         link.download = params.exportName+".xlsx";
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
      })
    })
  }



// WEBPACK FOOTER //
// ./src/utils/exportExcal.js